import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/out/order/setting/action/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/out/order/setting/action/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/out/order/setting/action/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/out/order/setting/action/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/out/order/setting/action/submit', params,options);

// 字典
export const getDictionary = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }))

export const availableActionList = (params, options) =>
  request.get('/api/v4ward/out/order/setting/action/availableActionList', Object.assign({}, options, { params }));

// 字典
export const getGroupList = (params, options) =>
    request.get('/api/v4ward/group/getGroupList', Object.assign({}, options, { params }))

export const updateStatus = (params, options) =>
  request.post('/api/v4ward/out/order/setting/action/updateStatus', params,options);
